module.exports = __webpack_public_path__ + "img/any-bg15.2701ff27.png";